
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.654","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.766 10.116a1.883 1.883 0 11-1.882-1.884 1.883 1.883 0 011.882 1.884zM10.106 1a1.884 1.884 0 101.884 1.884A1.884 1.884 0 0010.106 1zm11.335 3.216l-4.562 4.566m-5.645-4.4l3.312 4.4m-10.332 0l4.56-4.566m6.774 4.016a1.884 1.884 0 101.884 1.884 1.884 1.884 0 00-1.883-1.884zM22.771 1a1.884 1.884 0 101.882 1.884A1.884 1.884 0 0022.772 1z","fill":"none"}})])
          )
        }
      }
    